import {FloatingDropdown} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {StyledDropdownProps} from './interfaces'
import {classes} from './styled-dropdown.st.css'

export const StyledFloatingDropdown = ({options, ariaLabel, label, value, dataHook, onChange}: StyledDropdownProps) => {
  const {isMobile} = useEnvironment()

  return (
    <FloatingDropdown
      data-hook={dataHook}
      label={label}
      value={value}
      aria-label={ariaLabel}
      displayBlock={isMobile}
      className={classNames(classes.dropdown, {
        [classes.mobileDropdown]: isMobile,
        [classes.desktopDropdown]: !isMobile,
      })}
      options={options}
      onChange={onChange}
      placement="bottom-start"
    />
  )
}
